import script from "./StatusHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./StatusHistory.vue?vue&type=script&setup=true&lang=js"

import "./StatusHistory.vue?vue&type=style&index=0&id=94b8a00c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-94b8a00c"]])

export default __exports__